export default __webpack_public_path__ + "static/media/1536x600 cat looking to the side.6e590a59.jpg";